Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Tooltip2202527993",
  {"root":"Tooltip2202527993--root"},
  ".Tooltip2202527993--root .Popover2254595937--popoverContent{overflow-wrap:break-word;word-wrap:break-word;word-break:break-word}",
  2,
  "Tooltip2202527993"
);
__webpack_require__.stylable.$.register(exports.default)
